import { render, staticRenderFns } from "./ModalEditarMultiRecursos.vue?vue&type=template&id=66834e02&"
import script from "./ModalEditarMultiRecursos.vue?vue&type=script&lang=js&"
export * from "./ModalEditarMultiRecursos.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditarMultiRecursos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports